import { EventSearch } from '@eventbrite/discover-utils';
import { FormattedEvent } from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { DiscoverState } from '../../../../../types';
import SearchEventCardBucket from '../SearchEventCardBucket';

interface MoreEventsSectionProps {
    eventSearch: EventSearch;
    events?: FormattedEvent[];
    isLoading: boolean;
}

const MoreEventsSection: React.FunctionComponent<MoreEventsSectionProps> = ({
    eventSearch,
    events = [],
    isLoading,
}) => {
    const { q, page } = eventSearch;
    const bucketName = useMemo(() => {
        return q
            ? gettext('More %(query)s', {
                  query: q,
              })
            : gettext('More events');
    }, [q]);

    const displayedEvents = useMemo(() => {
        return events.slice(!page || page === 1 ? 9 : 0);
    }, [events, page]);

    if (!isLoading && !displayedEvents.length) {
        return null;
    }

    return (
        <SearchEventCardBucket
            events={displayedEvents}
            isLoading={isLoading}
            bucketName={bucketName}
            placeholderCardCount={12}
        />
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    eventSearch: state.search.eventSearch,
});

export default connect(_mapStateToProps)(MoreEventsSection);
